export default __webpack_public_path__ + "static/media/up-arrow.fb707b52.svg";